import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { action } from "typesafe-actions";
import { AppState } from "./../app-state";
import { GlobalTypes } from "./../global-types";
import { AuthActionTypes } from "./auth-types";
import { authenticationApi } from "../../api/talent/authentication-service";
import { CompanyProfileActionTypes } from "../company-profile/company-profile.types";
import { AxiosError } from "axios";

export const updateAuthenticationToken = (token: string) => action(AuthActionTypes.UPDATE_AUTHENTICATION_TOKEN, { token });

export const getUser = () => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(AuthActionTypes.GET_USER));
    dispatch(action(CompanyProfileActionTypes.GET_COMPANY_PROFILE));
    try {
      const response = await authenticationApi.getUser();
      dispatch(action(AuthActionTypes.GET_USER_SUCCESS, response?.data));
      dispatch(action(CompanyProfileActionTypes.GET_COMPANY_PROFILE_SUCCESS, response.data.user.corporate));
    } catch (error) {
      dispatch(action(AuthActionTypes.GET_USER_ERROR, error));
      dispatch(action(CompanyProfileActionTypes.GET_COMPANY_PROFILE_ERROR, error));
    }
  };
};

export const updateTermAccept = () => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(AuthActionTypes.UPDATE_TERM_ACCEPT));
    try {
      const response = await authenticationApi.updateTermAccept();
      dispatch(action(AuthActionTypes.UPDATE_TERM_ACCEPT_SUCCESS, response?.data));
    } catch (error) {
      dispatch(action(AuthActionTypes.UPDATE_TERM_ACCEPT_ERROR, error));
    }
  };
};

export const logout = () => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    window.sessionStorage.removeItem("i18n");
    dispatch(action(GlobalTypes.LOGOUT));

  };
};

export const clearGlobal = () => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    window.sessionStorage.removeItem("i18n");
    dispatch(action(GlobalTypes.CLEAR));
  };
}

export const fetchShowModal = (by_action: boolean) => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
      dispatch(action(AuthActionTypes.FETCH_SHOW_ACCOUNT_CONFIRMATION_MODAL, { by_action }));
  }
};

export const fetchHideModal = () => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
      dispatch(action(AuthActionTypes.FETCH_HIDE_ACCOUNT_CONFIRMATION_MODAL));
  }
};

export const sendEmailAccountConfirmation = (user_id: string, email?: string) => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(AuthActionTypes.SEND_EMAIL_ACCOUNT_CONFIRMATION));
        try {
            const response = await authenticationApi.talentToken(user_id, email);
            dispatch(action(AuthActionTypes.SEND_EMAIL_ACCOUNT_CONFIRMATION_SUCCESS, response.data));
        } catch (_error) {
            const error = _error as AxiosError;
            const status = error.response?.status;
            dispatch(action(AuthActionTypes.SEND_EMAIL_ACCOUNT_CONFIRMATION_ERROR, { status }));
        }
    }
}

export const confirmAccount = (user_id: string, token: string) => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(AuthActionTypes.ACCOUNT_CONFIRMATION));
        try {
            const response = await authenticationApi.talent_validate_email(user_id, token);
            dispatch(action(AuthActionTypes.ACCOUNT_CONFIRMATION_SUCCESS, response.data));
        } catch (_error) {
            const error = _error as AxiosError;
            const status = error.response?.status;
            dispatch(action(AuthActionTypes.ACCOUNT_CONFIRMATION_ERROR, { status }));
        }
    }
}
